import {Lang} from 'yougile-lang'

export const humanReadableYamlError = (e: Error): string => {
  if (e.name === 'YAMLParseError') {
    const msg = e.message
    if (msg?.includes('line ')) {
      const lineNum = msg.split('line ').pop().split(',')[0]
      const n = Number(lineNum)
      return n > 0 ? Lang.msg.workflow.errorInLine(n) : ''
    }
  }
  return ''
}
